// extracted by mini-css-extract-plugin
export default {"gutter":"20px","row":"Options-module_row__zjdTl","meta":"Options-module_meta__27hvR"};